import { constantCreator } from '~/utils/constantsCreator';
import api from '~/utils/api';

const constant = constantCreator('availability');
const GET_TRIP_AVAILABILITY = constant('GET_TRIP_AVAILABILITY', true);
const GET_TRIP_AVAILABILITY_V2 = constant('GET_TRIP_AVAILABILITY_V2', true);
const SELECT_DATE = constant('SELECT_DATE');
const TOGGLE_ACCEPT_SWAP = constant('TOGGLE_ACCEPT_SWAP');
const CLEAR = constant('CLEAR');

const initialState = {
  availabilities: [],
  selectedDate: '',
  isLoading: true,
  isError: false,
  isInstant: false,
  isReplaceable: false,
  acceptSwap: false,
  month: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TRIP_AVAILABILITY.PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
        month: action.month,
      };
    case GET_TRIP_AVAILABILITY.RESOLVED:
      return {
        ...state,
        isLoading: false,
        isError: false,
        availabilities: action.data,
      };
    case GET_TRIP_AVAILABILITY.REJECTED:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.error,
        availabilities: []
      };
    case GET_TRIP_AVAILABILITY_V2.PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
        month: action.month,
      };
    case GET_TRIP_AVAILABILITY_V2.RESOLVED:
      return {
        ...state,
        isLoading: false,
        isError: false,
        availabilities: action.data,
      };
    case GET_TRIP_AVAILABILITY_V2.REJECTED:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.error,
        availabilities: []
      };
    case SELECT_DATE:
      return {
        ...state,
        selectedDate: action.date,
        isInstant: action.status.isInstant,
        isReplaceable: action.status.isReplaceable
      };
    case TOGGLE_ACCEPT_SWAP:
      return {
        ...state,
        acceptSwap: !state.acceptSwap
      };
    case CLEAR:
      return {
        ...state,
        availabilities: [],
        selectedDate: '',
        isLoading: true,
        isError: false,
        isReplaceable: false,
        isInstant: false,
        acceptSwap: true,
        month: null,
      };
    default: return state;
  }
};

export default reducer;

export const actions = {
  getTripAvailability: (month, tripId, ticketIds = []) => ({
    month,
    type: GET_TRIP_AVAILABILITY,
    promise: api.get(`/availability/calendar?trip_id=${tripId}&month=${month}${ticketIds.length > 0 ? `&ticket_ids=${ticketIds.join(',')}` : ''}`)
  }),
  getTripAvailabilityV2: (month, tripId, ticketIds = []) => ({
    month,
    type: GET_TRIP_AVAILABILITY_V2,
    promise: api.get(`/availability/calendarv2?trip_id=${tripId}&month=${month}${ticketIds.length > 0 ? `&ticket_ids=${ticketIds.join(',')}` : ''}`)
  }),
  selectDate: (date, status = { isInstant: false, isReplaceable: false }) => ({
    type: SELECT_DATE,
    date,
    status
  }),
  clearAvailability: () => ({ type: CLEAR }),
  toggleAcceptSwap: () => ({ type: TOGGLE_ACCEPT_SWAP })
};
